import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'

import octicons from './octicons'
import colors from './colors'
import sizes from './sizes'
import styles from './styles'

const classes = StyleSheet.create(styles)

// FIXME static octicon classes leaning on Elemental to avoid duplicate
// font and CSS inflating the project size

export function Glyph({
  aphroditeStyles,
  className,
  color,
  component: Component,
  name,
  size,
  style,
  ...props
}) {
  const colorIsValidType = Object.keys(colors).includes(color)
  props.className =
    css(
      classes.glyph,
      colorIsValidType && classes['color__' + color],
      classes['size__' + size],
      aphroditeStyles
    ) + ` ${octicons[name]}`
  if (className) {
    props.className += ' ' + className
  }

  // support random color strings
  props.style = {
    color: !colorIsValidType ? color : null,
    margin: 4,
    ...style,
  }

  return <Component {...props} />
}

Glyph.defaultProps = {
  component: 'i',
  color: 'inherit',
  size: 'small',
}

export default Glyph
